import React, { useState } from "react";

const SearchBar = ({ onTermSubmit }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const onFormSubmit = (e) => {
    e.preventDefault();

    //TODO: MAKE SURE WE CALL BACK CALLBACK FROM PARENT COMPONENT
    onTermSubmit(searchTerm);
  };
  //
  //the ui segment is to give it a little triangle and make it pop => then we give it a form =>
  //then we give it a field in that form => then label
  return (
    <div className="searchbar__youtube">
      <form onSubmit={onFormSubmit} className="ui form">
        <div className="field">
          <label>Search for a video!</label>
          <input
            className="youtube-input"
            type="text"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          />
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
